const UserPointItem = ({
  code = '',
  label = '',
  labelEn = '',
  point = 0,
  ratio = 0,
  avg = 0,
  microscopeImages = [],
  interpretation = '',
  recommendation = '',
  sectionTitleColor = '',
  bgColor,
  borderColor,
  interpretationColor,
}) => {
  // position: 10 is left (Good), 0 is right (Bad)
  const userPercent = ((10 - point) / 10) * 100;
  const avgPercent = ((10 - avg) / 10) * 100;

  const valueColor = userPercent < avgPercent - 10 ? '#0EA5E9' : userPercent > avgPercent + 10 ? '#EF4444' : '#FACC15';
  // const clampedUserPercent = Math.max(2, Math.min(98, userPercent));

  return (
    <div className="bg-white rounded-xl shadow-medical border border-slate-200 overflow-hidden">
      {/* Header */}
      <div className="bg-slate-50 px-4 py-2 border-b border-slate-200 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="bg-slate-200 text-slate-600 text-[10px] font-mono font-bold px-1.5 py-0.5 rounded">
            {code}
          </span>
          <h4 className="text-sm font-bold text-slate-700">
            {label} <span className="text-xs font-normal text-slate-500">({labelEn})</span>
          </h4>
        </div>
        <span className="material-symbols-outlined text-slate-300 !text-lg">science</span>
      </div>

      {/* Body */}
      <div className="p-4">
        {/* Gauge bar */}
        <div className="relative h-6 w-full rounded-full bg-slate-100 mb-6 flex items-center px-1">
          {/* gradient track */}
          <div className="absolute inset-x-0 h-1.5 bg-gradient-to-r from-blue-400 via-slate-300 to-red-400 rounded-full top-1/2 -translate-y-1/2 mx-2"></div>
          {/* Avg line */}
          <div
            className="absolute w-0.5 h-3 bg-slate-400 top-1/2 -translate-y-1/2"
            style={{ left: `calc(8px + (100% - 16px) * ${avgPercent / 100})` }}
          ></div>
          {/* Avg label */}
          <div
            className="absolute text-[9px] text-slate-400 -top-3"
            style={{ left: `calc(8px + (100% - 16px) * ${avgPercent / 100})` }}
          >
            Avg
          </div>
          {/* User circle */}
          <div
            className="absolute w-4 h-4 bg-white border-2 border-primary rounded-full shadow top-1/2 -translate-y-1/2 z-10"
            style={{ left: `calc(8px + (100% - 32px) * ${userPercent / 100})`, borderColor: valueColor }}
          ></div>
          {/* Good / Bad labels */}
          <div className="w-full flex justify-between text-[9px] font-bold text-slate-400 relative z-0 mt-6 px-1">
            <span>Good</span>
            <span>Bad</span>
          </div>
        </div>

        <div className="flex justify-between gap-2 mb-6">
          {microscopeImages.map((src, i) => (
            <div key={i} className="w-16 h-16 rounded border border-slate-200 p-0.5 bg-white">
              <img
                className="w-full h-full object-cover rounded-sm mix-blend-multiply"
                src={src}
                alt={`microscope-${i}`}
              />
            </div>
          ))}
        </div>

        {/* Value + Rank */}
        <div className="grid grid-cols-2 gap-4 border-t border-slate-100 pt-4">
          <div className="border-r border-slate-100 pr-2">
            <div className="text-[10px] text-slate-400 mb-1">測定値 (Value)</div>
            <div className="text-2xl font-bold" style={{ color: valueColor }}>
              {Number(point).toFixed(3)}
            </div>
          </div>
          <div className="pl-2">
            <div className="text-[10px] text-slate-400 mb-1">上位% (Rank)</div>
            <div className="text-xl font-bold text-slate-700">
              Top {(Math.round(ratio * 10) / 10).toFixed(1)}
              <span className="text-sm font-normal">%</span>
            </div>
          </div>
        </div>
        {(interpretation || recommendation) && (
          <div
            className="space-y-3 bg-slate-50 p-2 border mt-2 rounded"
            style={{
              ...(bgColor && { backgroundColor: bgColor }),
              ...(borderColor && { borderColor: `${borderColor}` }),
            }}
          >
            {interpretation && (
              <div className={`flex items-start gap-3 text-xs`}>
                <span
                  className="text-[10px] font-bold text-slate-500 w-8 min-w-5"
                  style={{ ...(interpretationColor && { color: interpretationColor }) }}
                >
                  解釈
                </span>
                <span className="text-slate-700">{interpretation}</span>
              </div>
            )}
            {recommendation && (
              <div className={`flex items-start gap-3 text-xs`}>
                <span
                  className="text-[10px] font-bold whitespace-nowrap w-8 min-w-5"
                  style={{ color: sectionTitleColor }}
                >
                  推奨
                </span>
                <span className="text-slate-700">{recommendation}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserPointItem;
